import React from 'react';
import { createStore } from 'redux';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';

import axios from 'axios';

import Container from 'react-bootstrap/Container';

import MainBar from './MainBar';
import Protocol from './Protocol';
import ToolBox from './ToolBox';

export const psvDoctype = "<!DOCTYPE model SYSTEM \"http://metacp.eu/meta-cp.dtd?v=0.1\">";
export const exportDoctype = "<!DOCTYPE model SYSTEM \"meta-cp.dtd\">";

const initialState = {
    toolbox : <ToolBox />
  , protocol : undefined
  , backendopts : {
      enableMouseEvents: true
    }
};


export const metacpReducer = (state = initialState, action) => {
  switch(action.type) {
    case 0:
      return {toolbox: undefined};
    default:
      return state;
  }
};

export const metacp = createStore(metacpReducer);

export default class MetaCP extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    
    this.protRef = React.createRef();
  }
  
  toPSV = () => {
    var psv = "";
    
    if (this.protRef && this.protRef.current) {
      psv = this.protRef.current.toPSV();
    }
    
    return (
      <model version="0.1">
	{psv}
      </model>
    );
  }
  
  render() {
    this.state = metacp.getState();
    
    return (
      <DndProvider
        backend={HTML5Backend}
//         options={this.state.backendopts}
      >
        <Container className="metacp">
          <MainBar metacp={this} />
          <Protocol ref={this.protRef} />
        </Container>
      </DndProvider>
    );
  }
  
}
